import AppBar from "@mui/material/AppBar";
import GradientBackground from "../gradientBackground/GradientBackground";
import { PPConstants } from "@shared/publicportal/constants";
import useSessionStorage from "@mirage/hooks/useSessionStorage";
import { Tooltip } from "@mui/material";
import { memo } from "react";
import { useStableNavigate } from "@mirage/hooks/useStableNavigate";

interface BigLogoProps {
    navigateTo?: string;
    disableRedirectToBlank?: boolean;
}

const BigLogo = memo((props: BigLogoProps) => {
    const { navigateTo, disableRedirectToBlank } = props;
    const [sessionValue] = useSessionStorage(PPConstants.AppName);
    const navigate = useStableNavigate();
    const target = disableRedirectToBlank ? "_self" : "_blank";
    const redirectUrl = sessionValue.clientSettings?.CLIENT_WEBSITE_URL;
    const getLogo = () => {
        if (!sessionValue.clientSettings?.["logo.png"] && !sessionValue.clientSettings?.["logo.svg"]) {
            console.warn("No logo found in client settings");
            return;
        }
        let backgroundImage = "";
        if (sessionValue.clientSettings?.["logo.png"]) {
            backgroundImage = `url(data:image/png;base64,${sessionValue.clientSettings?.["logo.png"]})`;
        } else if (sessionValue.clientSettings?.["logo.svg"]) {
            backgroundImage = `url(data:image/svg+xml;base64,${sessionValue.clientSettings?.["logo.svg"]})`;
        }
        if (!backgroundImage) {
            return;
        }
        if (navigateTo) {
            const handleNavigate = () => navigate(navigateTo);
            return <span aria-label="Logo" className="logo big-logo cursor-pointer" onClick={handleNavigate} style={{ backgroundImage }}></span>;
        }
        if (!redirectUrl) {
            return <span aria-label="Logo" className="logo big-logo" style={{ backgroundImage }}></span>;
        }
        return (
            <Tooltip title="Go to website">
                <a aria-label="Go to website" href={redirectUrl} target={target} className={"logo big-logo"} style={{ backgroundImage }} rel="noreferrer"></a>
            </Tooltip>
        );
    };
    return (
        <>
            <GradientBackground />
            <AppBar className="custom-app-bar" position="absolute" sx={{ boxShadow: "none", top: "15px", backgroundColor: "transparent" }}>
                {getLogo()}
            </AppBar>
        </>
    );
});

export default BigLogo;
